import { Box, styled } from '@material-ui/core';
import { SText, SInput } from '@setvi/shared/components';
import { ROUTES } from 'enumsV2/routes';
import { Link } from 'react-router-dom';
import { Photo } from '../components';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '360px',
  overflow: 'auto',
  padding: theme.spacing(1, 3)
}));

const SectionTitle = styled(SText)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 600,
  color: '#333D47',
  margin: theme.spacing(1, 0, 3)
}));

interface PreparedByStepProps {
  data: {
    salesRepName: string;
    email: string;
    companyName: string;
    companyAddress: string;
    contactNumber?: string;
    photo?: string;
  };
  onChange: (data: any) => void;
  onImageUpload: (file: File) => void;
  emailError?: string;
  quoteId?: string;
}

export const PreparedByStep = ({
  data,
  onChange,
  onImageUpload,
  emailError,
  quoteId
}: PreparedByStepProps) => {
  const handleChange = (field: string, value: string) => {
    // Validate phone number to only allow digits, +, and -
    if (field === 'contactNumber') {
      const validPhonePattern = /^[\d+-]*$/;
      if (!validPhonePattern.test(value)) {
        return;
      }
    }

    // Validate email format - allow only valid email characters while typing
    if (field === 'email') {
      const validEmailPattern = /^[a-zA-Z0-9._%+-]*@?[a-zA-Z0-9.-]*$/;
      if (!validEmailPattern.test(value)) {
        return;
      }
    }

    onChange({
      ...data,
      [field]: value
    });
  };

  return (
    <Container>
      <SText size="lg" weight="bold">
        Prepared By
      </SText>

      <Box style={{ marginTop: 12, marginBottom: 10 }}>
        <Photo
          handleChange={(name, value, file) => {
            handleChange?.(name, value);
            onImageUpload?.(file || null);
          }}
          photo={data?.photo}
          alt={data?.salesRepName || ''}
        />
      </Box>

      <Box>
        <SInput
          newDesign
          fullWidth
          required
          label="Full Name"
          placeholder="Enter full name"
          value={data.salesRepName}
          onChange={e => handleChange('salesRepName', e.target.value)}
        />

        <SInput
          newDesign
          fullWidth
          required
          label="Phone Number"
          value={data.contactNumber}
          placeholder="Enter phone number"
          onChange={e => handleChange('contactNumber', e.target.value)}
        />

        <SInput
          newDesign
          fullWidth
          required
          label="Email Address"
          value={data.email}
          placeholder="Enter email address"
          onChange={e => handleChange('email', e.target.value)}
          error={!!emailError}
          helperText={emailError}
        />

        <SText size="sm" style={{ margin: '8px 0px 12px', color: '#5D7083' }}>
          To change the default profile settings, Please{' '}
          <Link
            to={`${ROUTES.SETTINGS_GENERAL}&quoteId=${quoteId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#2196F3', cursor: 'pointer' }}>
            Click Here
          </Link>
          .
        </SText>

        <SectionTitle>Company information</SectionTitle>

        <SInput
          newDesign
          label="Company Name"
          value={data.companyName}
          placeholder="Enter company name"
          disabled
          fullWidth
        />

        <SInput
          newDesign
          label="Address"
          value={data.companyAddress}
          placeholder="Enter address"
          disabled
          fullWidth
        />
      </Box>
    </Container>
  );
};
